export default {
  title: "电子商城",
  cookieExpires: 1,
  baseUrl: window.baseUrl,
  imageurl: window.imageurl,
  homeName: "home",
};
